const sec1 = {
  idSeccion: 'sec1',
  tituloSeccion: 'Punto de partida: datos clave',
  preguntas: [
    {
      idPregunta: 'preg1',
      enunciado: 'Para iniciar indícanos. ¿Cuál es el nombre de tu empresa? 🏭',
      tipo: 'libre',
    },
    {
      idPregunta: 'preg2',
      enunciado: '¿A qué Industria pertenece tu empresa?',
      tipo: 'libre',
    },
    {
      idPregunta: 'preg3',
      enunciado: '¿De qué país y ciudad es tu empresa?',
      tipo: 'libre',
    },
    {
      idPregunta: 'preg4',
      enunciado: '¿Actualmente qué cargo desempeñas en tu empresa?',
      tipo: 'unica opcion',
      opciones: [
        { etiqueta: 'Cargos C-Level', valor: null },
        { etiqueta: 'Empresario', valor: null },
        { etiqueta: 'Miembro administrativo', valor: null },
        { etiqueta: 'Representante legal', valor: null },
        { etiqueta: 'Directivo', valor: null },
        { etiqueta: 'Otro', especificar: true },
      ],
    },
    {
      idPregunta: 'preg5',
      enunciado: 'URL de la página web de tu empresa.',
      tipo: 'libre',
    },
    {
      idPregunta: 'preg6',
      enunciado: 'Danos una breve descripción de tu empresa',
      tipo: 'libre',
    },
    {
      idPregunta: 'preg7',
      enunciado: '¿Cuál es tu correo electrónico?',
      tipo: 'libre',
    },
  ],
};
const sec2 = {
  idSeccion: 'sec2',
  tituloSeccion: 'Horizontes: lo que aspiramos alcanzar',
  preguntas: [
    {
      idPregunta: 'preg8',
      enunciado:
        'Selecciona las opciones que se ajusten a tu meta con el proceso de digitalización. Elige tantas opciones como desees.',
      tipo: 'multiple opcion',
      opciones: [
        { etiqueta: 'Mejorar la experiencia del cliente' },
        { etiqueta: 'Aumentar la colaboración interna' },
        { etiqueta: 'Optimizar los procesos' },
        { etiqueta: 'Aumentar la eficiencia' },
        { etiqueta: 'Reducción de costos' },
        { etiqueta: 'Aumentar la productividad de los colaboradores' },
        { etiqueta: 'Cumplir con la seguridad de los datos' },
        { etiqueta: 'Obtener una ventaja competitiva' },
        { etiqueta: 'Aumentar al máximo los ingresos' },
      ],
    },
    {
      idPregunta: 'preg9',
      enunciado:
        '¿Cómo evalúas el éxito de tu empresa al hacer cambios en la estrategia empresarial? Elige tantas opciones como desees.',
      tipo: 'multiple opcion',
      opciones: [
        { etiqueta: 'Crecimiento de ingresos' },
        { etiqueta: 'Éxito en las rondas de financiamiento' },
        { etiqueta: 'Expansión nacional' },
        { etiqueta: 'Expansión internacional' },
        { etiqueta: 'Tecnología más robusta' },
        { etiqueta: 'Eficiencia de los colaboradores' },
        { etiqueta: 'Otro', especificar: true },
      ],
    },
    {
      idPregunta: 'preg10',
      enunciado:
        '¿Qué consideras que ha sido lo más difícil a la hora de hacer una transformación digital? Elige tantas opciones como desees.',
      tipo: 'multiple opcion',
      opciones: [
        { etiqueta: 'Falta de tiempo' },
        { etiqueta: 'Poco presupuesto' },
        { etiqueta: 'Personal no capacitado' },
        { etiqueta: 'Poca ayuda de los directivos' },
        { etiqueta: 'Desconocimiento del ecosistema' },
        { etiqueta: 'Falta de cultura digital' },
        { etiqueta: 'Desconocimiento de los métodos' },
        { etiqueta: 'Falta de mentalidad' },
        { etiqueta: 'Falta de un modelo de negocio claro' },
        { etiqueta: 'Falta de liderazgo' },
        { etiqueta: 'Falta de capital humano' },
        { etiqueta: 'Otro', especificar: true },
      ],
    },
  ],
};
const sec3 = {
  idSeccion: 'sec3',
  tituloSeccion: 'Estrategia digital y empresarial',
  preguntas: [
    {
      idPregunta: 'preg11',
      enunciado:
        '¿Cómo describirías la integración de tu estrategia digital con tu estrategia empresarial general?',
      tipo: 'unica opcion',
      opciones: [
        { etiqueta: 'No tenemos una estrategia digital definida', valor: 0.15 },
        {
          etiqueta:
            'Tenemos una estrategia digital, pero está poco integrada con la estrategia empresarial',
          valor: 0.33,
        },
        {
          etiqueta:
            'Nuestra estrategia digital y empresarial están alineadas y se refuerzan mutuamente',
          valor: 0.66,
        },
        {
          etiqueta:
            'La estrategia digital es fundamental en nuestra estrategia empresarial y nos guía en la toma de decisiones',
          valor: 1.0,
        },
      ],
    },
    {
      idPregunta: 'preg12',
      enunciado:
        '¿En qué medida los objetivos digitales están definidos y son conocidos por toda tu empresa?',
      tipo: 'unica opcion',
      opciones: [
        { etiqueta: 'No tenemos objetivos digitales claros', valor: 0.15 },
        {
          etiqueta:
            'Tenemos algunos objetivos digitales, pero no son conocidos por toda la organización',
          valor: 0.33,
        },
        {
          etiqueta:
            'Los objetivos digitales están definidos y son parcialmente conocidos por la organización',
          valor: 0.66,
        },
        {
          etiqueta:
            'Los objetivos digitales están claramente definidos y son ampliamente conocidos y compartidos en toda la organización',
          valor: 1.0,
        },
      ],
    },
    {
      idPregunta: 'preg13',
      enunciado:
        '¿Cómo se priorizan las inversiones en tecnología digital en tu empresa?',
      tipo: 'unica opcion',
      opciones: [
        {
          etiqueta:
            'Las inversiones en tecnología digital son esporádicas y no están priorizadas',
          valor: 0.15,
        },
        {
          etiqueta:
            'Realizamos algunas inversiones basadas en necesidades inmediatas sin una estrategia a largo plazo',
          valor: 0.33,
        },
        {
          etiqueta:
            'Tenemos un plan de inversión tecnológica que considera las necesidades actuales y futuras',
          valor: 0.66,
        },
        {
          etiqueta:
            'La inversión en tecnología digital es estratégica y se alinea con los objetivos a largo plazo de nuestra empresa',
          valor: 1.0,
        },
      ],
    },
    {
      idPregunta: 'preg14',
      enunciado:
        '¿Cuál es el nivel de entendimiento digital entre los líderes de tu empresa?',
      tipo: 'unica opcion',
      opciones: [
        { etiqueta: 'Bajo o inexistente', valor: 0.15 },
        {
          etiqueta: 'Los líderes tienen un entendimiento básico de lo digital',
          valor: 0.33,
        },
        {
          etiqueta:
            'Los líderes tienen un buen entendimiento y promueven activamente la digitalización',
          valor: 0.66,
        },
        {
          etiqueta:
            'Los líderes son expertos digitales y son campeones de la transformación digital',
          valor: 1.0,
        },
      ],
    },
    {
      idPregunta: 'preg15',
      enunciado:
        '¿Cómo se comunica y se implementa la estrategia digital en tu empresa?',
      tipo: 'unica opcion',
      opciones: [
        {
          etiqueta: 'No se comunica de manera efectiva ni se implementa',
          valor: 0.15,
        },
        {
          etiqueta: 'Se comunica, pero su implementación es irregular',
          valor: 0.33,
        },
        {
          etiqueta:
            'Se comunica claramente y se está en proceso de implementación en toda la organización',
          valor: 0.66,
        },
        {
          etiqueta:
            'Se comunica e implementa de manera eficaz y es parte integral de nuestras operaciones diarias',
          valor: 1.0,
        },
      ],
    },
  ],
};
const sec4 = {
  idSeccion: 'sec4',
  tituloSeccion: 'Experiencia de cliente',
  preguntas: [
    {
      idPregunta: 'preg16',
      enunciado:
        '¿Cómo utilizas en tu empresa los canales digitales para interactuar con los clientes? (Página web, redes sociales, blogs, aplicaciones, software, crm de comunicación…)',
      tipo: 'unica opcion',
      opciones: [
        { etiqueta: 'Raramente utilizamos canales digitales', valor: 0.15 },
        {
          etiqueta:
            'Usamos canales digitales de forma básica para algunas interacciones',
          valor: 0.33,
        },
        {
          etiqueta:
            'Integración media de canales digitales, con algunas personalizaciones',
          valor: 0.66,
        },
        {
          etiqueta:
            'Uso avanzado de canales digitales, con experiencias altamente personalizadas',
          valor: 1.0,
        },
      ],
    },
    {
      idPregunta: 'preg17',
      enunciado:
        '¿En qué medida tu empresa recopila y utiliza datos de clientes para mejorar la experiencia?',
      tipo: 'unica opcion',
      opciones: [
        {
          etiqueta: 'No recopilamos ni utilizamos datos de clientes',
          valor: 0.15,
        },
        {
          etiqueta:
            'Recopilamos algunos datos, pero no los utilizamos efectivamente',
          valor: 0.33,
        },
        {
          etiqueta:
            'Utilizamos datos de clientes para mejorar algunas áreas de la experiencia',
          valor: 0.66,
        },
        {
          etiqueta:
            'La recopilación y uso de datos está totalmente integrada para personalizar y mejorar continuamente la experiencia del cliente',
          valor: 1.0,
        },
      ],
    },
    {
      idPregunta: 'preg18',
      enunciado:
        '¿Cómo calificarías la coherencia de la experiencia del cliente a través de diferentes canales digitales?',
      tipo: 'unica opcion',
      opciones: [
        {
          etiqueta: 'Inconsistente o inexistente',
          valor: 0.15,
        },
        {
          etiqueta: 'Básica y a veces coherente',
          valor: 0.33,
        },
        {
          etiqueta: 'Generalmente coherente, con áreas de mejora',
          valor: 0.66,
        },
        {
          etiqueta: 'Totalmente coherente y optimizada en todos los canales',
          valor: 1.0,
        },
      ],
    },
    {
      idPregunta: 'preg19',
      enunciado:
        '¿Cuál es la integración del marketing digital con otras estrategias de la empresa, como ventas y servicio al cliente?',
      tipo: 'unica opcion',
      opciones: [
        {
          etiqueta: 'Poca o ninguna integración con otras estrategias.',
          valor: 0.15,
        },
        {
          etiqueta: 'Alguna integración, pero no se maximizan las sinergias.',
          valor: 0.33,
        },
        {
          etiqueta:
            'Integración efectiva y sinérgica con otras estrategias empresariales.',
          valor: 0.66,
        },
        {
          etiqueta:
            'Integración total que optimiza el ciclo completo del cliente.',
          valor: 1.0,
        },
      ],
    },
    {
      idPregunta: 'preg20',
      enunciado:
        '¿Cuál es el nivel de satisfacción del cliente con las interacciones digitales?',
      tipo: 'unica opcion',
      opciones: [
        {
          etiqueta: 'No conocemos el nivel de satisfacción del cliente',
          valor: 0.15,
        },
        {
          etiqueta:
            'El nivel de satisfacción es variado y no se mide sistemáticamente',
          valor: 0.33,
        },
        {
          etiqueta: 'Tenemos medidas de satisfacción y trabajamos en mejoras',
          valor: 0.66,
        },
        {
          etiqueta:
            'Alto nivel de satisfacción del cliente, con mejoras continuas basadas en feedback',
          valor: 1.0,
        },
      ],
    },
    {
      idPregunta: 'preg21',
      enunciado:
        '¿Cómo se manejan los feedbacks y quejas de clientes en canales digitales?',
      tipo: 'unica opcion',
      opciones: [
        {
          etiqueta: 'No se manejan de manera efectiva',
          valor: 0.15,
        },
        {
          etiqueta: 'Se manejan, pero sin un proceso sistemático',
          valor: 0.33,
        },
        {
          etiqueta:
            'Tenemos un proceso para gestionar feedbacks, pero hay margen de mejora',
          valor: 0.66,
        },
        {
          etiqueta:
            'El manejo de feedbacks y quejas es proactivo y contribuye a la mejora continua',
          valor: 1.0,
        },
      ],
    },
  ],
};
const sec5 = {
  idSeccion: 'sec5',
  tituloSeccion: 'Cultura innovadora y liderazgo',
  preguntas: [
    {
      idPregunta: 'preg22',
      enunciado: '¿Cómo describirías la cultura de innovación en tu empresa?',
      tipo: 'unica opcion',
      opciones: [
        {
          etiqueta: 'No fomentamos activamente una cultura de innovación',
          valor: 0.15,
        },
        {
          etiqueta: 'La innovación ocurre, pero no es una prioridad clara',
          valor: 0.33,
        },
        {
          etiqueta:
            'La innovación es parte de nuestra cultura, aunque de manera inconsistente',
          valor: 0.66,
        },
        {
          etiqueta: 'La innovación está en el centro de todo lo que hacemos',
          valor: 1.0,
        },
      ],
    },
    {
      idPregunta: 'preg23',
      enunciado:
        '¿En qué medida los empleados están empoderados para probar nuevas ideas y tecnologías?',
      tipo: 'unica opcion',
      opciones: [
        {
          etiqueta: 'Raramente se permite o se incentiva la experimentación',
          valor: 0.15,
        },
        {
          etiqueta:
            'Se permite en ciertos casos, pero no se incentiva ampliamente',
          valor: 0.33,
        },
        {
          etiqueta:
            'Los empleados están generalmente empoderados para experimentar',
          valor: 0.66,
        },
        {
          etiqueta:
            'La experimentación es una expectativa y está ampliamente apoyada en toda la organización',
          valor: 1.0,
        },
      ],
    },
    {
      idPregunta: 'preg24',
      enunciado:
        '¿Cuál es el nivel de apoyo y compromiso del liderazgo con la innovación digital?',
      tipo: 'unica opcion',
      opciones: [
        {
          etiqueta:
            'El liderazgo no muestra un compromiso claro con la innovación digital',
          valor: 0.15,
        },
        {
          etiqueta: 'Hay un compromiso moderado, pero falta liderazgo activo',
          valor: 0.33,
        },
        {
          etiqueta:
            'El liderazgo apoya la innovación digital y participa activamente',
          valor: 0.66,
        },
        {
          etiqueta:
            'El liderazgo es el principal impulsor de la innovación digital y modela este comportamiento',
          valor: 1.0,
        },
      ],
    },
    {
      idPregunta: 'preg25',
      enunciado:
        '¿Cómo se fomenta y reconoce la innovación dentro en tu empresa?',
      tipo: 'unica opcion',
      opciones: [
        {
          etiqueta:
            'No hay un reconocimiento o incentivo claro para la innovación.',
          valor: 0.15,
        },
        {
          etiqueta: 'Hay algún reconocimiento, pero no está bien estructurado.',
          valor: 0.33,
        },
        {
          etiqueta:
            'Reconocemos y recompensamos la innovación, aunque de forma limitada.',
          valor: 0.66,
        },
        {
          etiqueta:
            'Tenemos sistemas sólidos para fomentar, reconocer y recompensar la innovación.',
          valor: 1.0,
        },
      ],
    },
    {
      idPregunta: 'preg26',
      enunciado:
        '¿Cómo describirías la capacidad de tu empresa para adaptarse a cambios tecnológicos y de mercado?',
      tipo: 'unica opcion',
      opciones: [
        {
          etiqueta: 'Nos cuesta adaptarnos a cambios',
          valor: 0.15,
        },
        {
          etiqueta: 'Nos adaptamos a cambios, pero lentamente',
          valor: 0.33,
        },
        {
          etiqueta:
            'Somos bastante ágiles adaptándonos a cambios, aunque con retos',
          valor: 0.66,
        },
        {
          etiqueta: 'La adaptabilidad es una de nuestras fortalezas clave',
          valor: 1.0,
        },
      ],
    },
    {
      idPregunta: 'preg27',
      enunciado:
        '¿Cómo se prepara tu empresa para el futuro digital, considerando tendencias emergentes y disruptivas?',
      tipo: 'unica opcion',
      opciones: [
        {
          etiqueta: 'Raramente consideramos tendencias futuras',
          valor: 0.15,
        },
        {
          etiqueta: 'Consideramos tendencias futuras, pero de manera ad hoc',
          valor: 0.33,
        },
        {
          etiqueta:
            'Activamente, seguimos y evaluamos tendencias para prepararnos para el futuro',
          valor: 0.66,
        },
        {
          etiqueta:
            'La preparación para el futuro es estratégica, basada en análisis profundos de tendencias y adaptaciones proactivas',
          valor: 1.0,
        },
      ],
    },
  ],
};
const sec6 = {
  idSeccion: 'sec6',
  tituloSeccion: 'Estado legal en entornos digitales y empresariales',
  preguntas: [
    {
      idPregunta: 'preg28',
      enunciado:
        '¿Cómo describirías el cumplimiento legal y normativo de tu empresa en el entorno digital?',
      tipo: 'unica opcion',
      opciones: [
        {
          etiqueta: 'No estamos seguros de nuestro cumplimiento',
          valor: 0.15,
        },
        {
          etiqueta: 'Cumplimos con los requisitos básicos',
          valor: 0.33,
        },
        {
          etiqueta:
            'Cumplimos con la mayoría de los requisitos y estamos trabajando en las brechas',
          valor: 0.66,
        },
        {
          etiqueta:
            'Tenemos un cumplimiento total y revisamos constantemente nuestras prácticas',
          valor: 1.0,
        },
      ],
    },
    {
      idPregunta: 'preg29',
      enunciado:
        '¿En qué medida se implementan prácticas de protección de datos y privacidad en tu empresa?',
      tipo: 'unica opcion',
      opciones: [
        {
          etiqueta: 'Tenemos prácticas limitadas o inexistentes',
          valor: 0.15,
        },
        {
          etiqueta: 'Implementamos algunas prácticas básicas',
          valor: 0.33,
        },
        {
          etiqueta: 'Tenemos prácticas sólidas, pero con margen de mejora',
          valor: 0.66,
        },
        {
          etiqueta:
            'Nuestras prácticas son líderes en la industria, con revisiones y mejoras continuas',
          valor: 1.0,
        },
      ],
    },
    {
      idPregunta: 'preg30',
      enunciado:
        ' ¿Cómo gestionas en tu empresa los derechos de propiedad intelectual en el entorno digital?',
      tipo: 'unica opcion',
      opciones: [
        {
          etiqueta: 'No tenemos un enfoque claro o estructurado',
          valor: 0.15,
        },
        {
          etiqueta:
            'Gestionamos los derechos básicos, pero no de manera sistemática',
          valor: 0.33,
        },
        {
          etiqueta:
            'Tenemos un sistema para gestionar y proteger los derechos de propiedad intelectual',
          valor: 0.66,
        },
        {
          etiqueta:
            'Protegemos activamente y maximizamos el valor de nuestra propiedad intelectual digital',
          valor: 1.0,
        },
      ],
    },
    {
      idPregunta: 'preg31',
      enunciado:
        '¿Cómo manejas los aspectos legales de la transformación digital en tu empresa?',
      tipo: 'unica opcion',
      opciones: [
        {
          etiqueta:
            'No tenemos un enfoque específico para los aspectos legales de la transformación digital.',
          valor: 0.15,
        },
        {
          etiqueta:
            'Estamos comenzando a considerar los aspectos legales en nuestros proyectos digitales.',
          valor: 0.33,
        },
        {
          etiqueta:
            'Los aspectos legales son una parte integral de nuestra planificación y ejecución de proyectos digitales.',
          valor: 0.66,
        },
        {
          etiqueta:
            'Integración proactiva y avanzada de consideraciones legales en todas las fases de la transformación digital.',
          valor: 1.0,
        },
      ],
    },
  ],
};
const sec7 = {
  idSeccion: 'sec7',
  tituloSeccion: 'Nivel tecnológico y de automatización',
  preguntas: [
    {
      idPregunta: 'preg32',
      enunciado:
        '¿Cómo calificaría la infraestructura tecnológica de tu empresa?',
      tipo: 'unica opcion',
      opciones: [
        {
          etiqueta: 'Obsoleta o insuficiente para nuestras necesidades',
          valor: 0.15,
        },
        {
          etiqueta:
            'Adecuada para las operaciones actuales, pero con limitaciones para la expansión o innovación',
          valor: 0.33,
        },
        {
          etiqueta: 'Moderna y escalable, con algunas áreas para mejora',
          valor: 0.66,
        },
        {
          etiqueta:
            'Estado del arte, constantemente actualizada y escalable para futuras necesidades',
          valor: 1.0,
        },
      ],
    },
    {
      idPregunta: 'preg33',
      enunciado: 'No utilizamos la automatización de procesos',
      tipo: 'unica opcion',
      opciones: [
        {
          etiqueta: 'Tenemos prácticas limitadas o inexistentes',
          valor: 0.15,
        },
        {
          etiqueta: 'Implementamos algunas prácticas básicas',
          valor: 0.33,
        },
        {
          etiqueta:
            'Tenemos un nivel medio de automatización en varios procesos clave',
          valor: 0.66,
        },
        {
          etiqueta: 'La automatización es extensa y se optimiza continuamente',
          valor: 1.0,
        },
      ],
    },
    {
      idPregunta: 'preg34',
      enunciado: '¿Cómo gestionas los datos y la analítica en tu empresa?',
      tipo: 'unica opcion',
      opciones: [
        {
          etiqueta: 'La gestión de datos es básica y no utilizamos analítica',
          valor: 0.15,
        },
        {
          etiqueta: 'Usamos analítica básica para decisiones operativas',
          valor: 0.33,
        },
        {
          etiqueta:
            'La analítica avanzada informa algunas decisiones estratégicas',
          valor: 0.66,
        },
        {
          etiqueta:
            'La analítica de datos es central en nuestra estrategia y toma de decisiones',
          valor: 1.0,
        },
      ],
    },
    {
      idPregunta: 'preg35',
      enunciado:
        '¿Cómo gestionas los fallos tecnológicos y los incidentes de seguridad?',
      tipo: 'unica opcion',
      opciones: [
        {
          etiqueta: 'La gestión de fallos e incidentes es reactiva.',
          valor: 0.15,
        },
        {
          etiqueta:
            'Tenemos procedimientos básicos para manejar fallos e incidentes.',
          valor: 0.33,
        },
        {
          etiqueta:
            'Gestionamos proactivamente fallos e incidentes, con espacio para mejorar.',
          valor: 0.66,
        },
        {
          etiqueta:
            'Contamos con un enfoque avanzado y proactivo para gestionar fallos e incidentes.',
          valor: 1.0,
        },
      ],
    },
    {
      idPregunta: 'preg36',
      enunciado:
        '¿Cómo calificaría la integración de nuevas tecnologías en tu empresa?',
      tipo: 'unica opcion',
      opciones: [
        {
          etiqueta: 'Raramente integramos nuevas tecnologías.',
          valor: 0.15,
        },
        {
          etiqueta: 'Integramos nuevas tecnologías, pero el proceso es lento',
          valor: 0.33,
        },
        {
          etiqueta:
            'Somos proactivos en la integración de tecnología, aunque con algunos retos.',
          valor: 0.66,
        },
        {
          etiqueta:
            'La integración de tecnología es rápida, eficiente y parte de nuestra cultura.',
          valor: 1.0,
        },
      ],
    },
    {
      idPregunta: 'preg37',
      enunciado:
        ' ¿Cómo aseguras que tu empresa mantenga la seguridad tecnológica?',
      tipo: 'unica opcion',
      opciones: [
        {
          etiqueta: 'La seguridad tecnológica es un área de mejora.',
          valor: 0.15,
        },
        {
          etiqueta: 'Tenemos medidas de seguridad básicas',
          valor: 0.33,
        },
        {
          etiqueta:
            'Contamos con una sólida seguridad tecnológica, con espacio para mejoras.',
          valor: 0.66,
        },
        {
          etiqueta:
            'La seguridad es líder en la industria, con revisiones constantes para enfrentar nuevas amenazas.',
          valor: 1.0,
        },
      ],
    },
  ],
};
const sec8 = {
  idSeccion: 'sec8',
  tituloSeccion: 'Gestión del riesgo',
  preguntas: [
    {
      idPregunta: 'preg38',
      enunciado:
        '¿Cómo identificar y gestionar en tu empresa los riesgos digitales?',
      tipo: 'unica opcion',
      opciones: [
        {
          etiqueta:
            'No tenemos un proceso formal para la gestión de riesgos digitales',
          valor: 0.15,
        },
        {
          etiqueta: 'Identificamos algunos riesgos, pero la gestión es básica',
          valor: 0.33,
        },
        {
          etiqueta:
            'Tenemos procesos para identificar y gestionar riesgos, aunque mejorable',
          valor: 0.66,
        },
        {
          etiqueta:
            'La gestión de riesgos es proactiva, integral y constantemente actualizada',
          valor: 1.0,
        },
      ],
    },
    {
      idPregunta: 'preg39',
      enunciado: '¿Cómo gestionas el riesgo en la innovación?',
      tipo: 'unica opcion',
      opciones: [
        {
          etiqueta: 'Evitamos riesgos, lo que limita nuestra innovación',
          valor: 0.15,
        },
        {
          etiqueta: 'Aceptamos algunos riesgos, pero de manera cautelosa',
          valor: 0.33,
        },
        {
          etiqueta:
            'Tenemos un enfoque equilibrado que permite cierto riesgo, con controles',
          valor: 0.66,
        },
        {
          etiqueta:
            'Abrazamos el riesgo como una parte necesaria de la innovación',
          valor: 1.0,
        },
      ],
    },
    {
      idPregunta: 'preg40',
      enunciado:
        '¿Cuál es el nivel de preparación de tu empresa ante ciberataques?',
      tipo: 'unica opcion',
      opciones: [
        {
          etiqueta: 'Bajo o inexistente',
          valor: 0.15,
        },
        {
          etiqueta: 'Tenemos algunas medidas básicas de protección',
          valor: 0.33,
        },
        {
          etiqueta:
            'Estamos razonablemente preparados, con planes de respuesta a incidentes',
          valor: 0.66,
        },
        {
          etiqueta:
            'Muy alto, con defensas avanzadas y planes de respuesta robustos',
          valor: 1.0,
        },
      ],
    },
    {
      idPregunta: 'preg41',
      enunciado:
        '¿Cómo gestionas la continuidad del negocio ante interrupciones digitales?',
      tipo: 'unica opcion',
      opciones: [
        {
          etiqueta: 'No tenemos un plan de continuidad del negocio.',
          valor: 0.15,
        },
        {
          etiqueta:
            'Tenemos un plan básico, pero no está completamente desarrollado.',
          valor: 0.33,
        },
        {
          etiqueta:
            'Nuestro plan de continuidad del negocio es sólido, con algunos aspectos por mejorar.',
          valor: 0.66,
        },
        {
          etiqueta:
            'Contamos con un plan integral de continuidad del negocio, probado y actualizado regularmente.',
          valor: 1.0,
        },
      ],
    },
    {
      idPregunta: 'preg42',
      enunciado:
        '¿Cómo evalúas el impacto de las nuevas tecnologías en los riesgos empresariales?',
      tipo: 'unica opcion',
      opciones: [
        {
          etiqueta: 'No evaluamos sistemáticamente el impacto.',
          valor: 0.15,
        },
        {
          etiqueta: 'Evaluamos el impacto ocasionalmente.',
          valor: 0.33,
        },
        {
          etiqueta:
            'Realizamos evaluaciones regulares del impacto tecnológico en los riesgos.',
          valor: 0.66,
        },
        {
          etiqueta:
            'La evaluación del impacto tecnológico es parte integral de nuestra gestión de riesgos.',
          valor: 1.0,
        },
      ],
    },
    {
      idPregunta: 'preg43',
      enunciado:
        '¿Cómo comunicás y entrenas a los empleados sobre riesgos digitales y seguridad?',
      tipo: 'unica opcion',
      opciones: [
        {
          etiqueta:
            'La comunicación y entrenamiento son limitados o inexistentes.',
          valor: 0.15,
        },
        {
          etiqueta:
            'Se realiza cierta comunicación y entrenamiento, pero no de manera sistemática.',
          valor: 0.33,
        },
        {
          etiqueta:
            'Contamos con programas de comunicación y entrenamiento, con áreas de mejora.',
          valor: 0.66,
        },
        {
          etiqueta:
            'La comunicación y el entrenamiento en riesgos y seguridad son integrales y continuos.',
          valor: 1.0,
        },
      ],
    },
  ],
};

const preguntas = {
  idDiagnostico: 'diag001',
  tituloDiagnostico: 'Evaluación de Digitalización Empresarial',
  secciones: [sec1, sec2, sec3, sec4, sec5, sec6, sec7, sec8],
};

export default preguntas;
